import _classCallCheck from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import React from 'react';
import f7 from '../utils/f7';

var F7RoutableModals =
/*#__PURE__*/
function (_React$Component) {
  _inherits(F7RoutableModals, _React$Component);

  function F7RoutableModals(props, context) {
    var _this;

    _classCallCheck(this, F7RoutableModals);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(F7RoutableModals).call(this, props, context));
    _this.__reactRefs = {};

    _this.state = function () {
      return {
        modals: []
      };
    }();

    return _this;
  }

  _createClass(F7RoutableModals, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement('div', {
        ref: function ref(__reactNode) {
          _this2.__reactRefs['el'] = __reactNode;
        },
        className: 'framework7-modals'
      }, this.state.modals.map(function (modal) {
        var ModalComponent = modal.component;
        {
          return React.createElement(ModalComponent, Object.assign({
            key: modal.id
          }, modal.props));
        }
      }));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var self = this;
      var el = self.refs.el;
      self.routerData = {
        modals: self.state.modals,
        el: el,
        component: self,
        setModals: function setModals(modals) {
          self.setState({
            modals: modals
          });
        }
      };
      f7.routers.modals = self.routerData;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var self = this;
      if (!self.routerData) return;
      f7.routers.modals = null;
      self.routerData = null;
      delete self.routerData;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var self = this;
      if (!self.routerData) return;
      f7.events.emit('modalsRouterDidUpdate', self.routerData);
    }
  }, {
    key: "refs",
    get: function get() {
      return this.__reactRefs;
    },
    set: function set(refs) {}
  }]);

  return F7RoutableModals;
}(React.Component);

F7RoutableModals.displayName = 'f7-routable-modals';
export default F7RoutableModals;